import { t } from '@bia-auction/shared-i18n';
import type { PresentationStatus } from '@bia-auction/shared-schema';

/** Localized label for a sale's public presentation status (`presentation.*` keys). */
export function presentationLabel(status: PresentationStatus): string {
  return t(`presentation.${status}`);
}
